import { createContext, useContext } from 'react';
export const SidebarV2Context = createContext(null);
export const useSidebarV2 = () => useContext(SidebarV2Context);
export const SIDEBAR_V2_FLAG = 'graphql-sidebar-v2';
//# sourceMappingURL=context.js.map